export const Pay = ({ handleSubmit }) => {
    return (
        <button className="w-full max-w-sm space-y-2 mt-auto" onClick={() => handleSubmit()}>
            <p className="text-2xl ">PLAČAJ</p>
        </button>
    );
};



